import React, { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const StopsV2 = lazy(() => import('./stops-v2'));

const StopsV2AppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/apps/stops-control',
      element: <StopsV2 />,
    },
  ],
};

export default StopsV2AppConfig;